import * as React from 'react';
import { translate } from 'components/translate-hoc';
import { ICommonFieldProps } from './fields.types';
import { getModeClass } from 'utils/css';
import { IValidationError } from '../additional-info.types';

export const IntField: React.FC<ICommonFieldProps> = (props: ICommonFieldProps) => {
    const {
        shouldInheritStyles,
        meta,
        input,
        translatePrefix,
        dangerouslyTranslateWithHTML: translateKey
    } = props;

    const className = getModeClass('sitegen-int-field', shouldInheritStyles);
    const labelText = translateKey(`${translatePrefix}${input.name}`);
    const metaError = meta.error as IValidationError;
    const isWarning = metaError && meta.submitFailed;
    const errorMessage = isWarning
        ? translateKey(`${translatePrefix}${metaError.message}`, { ...(metaError.data ? metaError.data : {})})
        : '';

    return (
        <div className={className}>
            <div className={`${className}__label`}>{labelText}</div>
            <div className={`${className}__container`}>
                <input {...input} type="text" className={`${className}__input`} />
                <div className={`${className}__error`}>{errorMessage}</div>
            </div>
        </div>
    );
};

export default translate()(IntField);
